import axios from 'axios'
import { camelizeKeys } from 'humps'

import type { FetchLocationResponse } from './types'
import errorLogging from 'services/error-logging'
import cookies from 'services/cookies'

const IP_INFO_URL = process.env.IP_INFO_URL

export function fetchLocation() {
  const token = cookies.getAccessToken()

  return axios
    .get(`${IP_INFO_URL}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data }) => {
      const { countryCode, latitude, longitude } = (camelizeKeys(
        data,
      ) as unknown) as FetchLocationResponse
      return {
        countryCode,
        latitude,
        longitude,
      }
    })
    .catch((error) => {
      errorLogging(new Error('failed fetching location information'), { error })
    })
}
